import React, { useEffect, useState } from 'react';
import ObtenerPrestador from '../functions/ObtenerPrestador';
import ObtenerEspecialidadesPorPrestador from '../functions/ObtenerEspecialidadesPorPrestador';
import ObtenerPlanesPorPrestador from './ObtenerPlanesPorPrestador';
import EspecialidadSeleccionar from '../types/EspecialidadSeleccionar';
import PrestadorSeleccionar from '../types/PrestadorSeleccionar';
import PlanSeleccionar from '../types/PlanSeleccionar';

const ObtenerPrestadorEspecialidades = async (idPrestador: number): Promise<PrestadorSeleccionar> => {

    if (idPrestador > 0) {
        
        // Recupero los datos del prestador
        
        const dataPrestador = await ObtenerPrestador(idPrestador);

        if (dataPrestador.prestador_ok === 'si') {

            // Recupero las especialidades del prestador
            const dataPrestadorEspecialidades = await ObtenerEspecialidadesPorPrestador(idPrestador);
            const dataPrestadorPlanes = await ObtenerPlanesPorPrestador(idPrestador);
            
            if (dataPrestadorEspecialidades.especialidades_prestador_ok === 'si' && dataPrestadorPlanes.planes_prestador_ok === 'si') {
                
                // Armo el arreglo de especialidades del prestador
                const especialidadesPrestadorRecuperadas: EspecialidadSeleccionar[] = [];
                for (const especialidad_prestador of dataPrestadorEspecialidades.especialidades_prestador) {
                    especialidadesPrestadorRecuperadas.push({
                        id: especialidad_prestador.especialidad_id,
                        especialidad: especialidad_prestador.especialidad
                    });
                }

                const planesPrestadorRecuperados: PlanSeleccionar[] = [];
                for (const plan_prestador of dataPrestadorPlanes.planes_prestador) {
                    planesPrestadorRecuperados.push({
                        id: plan_prestador.plan_id,
                        title: plan_prestador.title
                    });
                }
                
                // Armo el prestador recuperado con las especialidades que ya tiene
                const prestadorRecuperado: PrestadorSeleccionar = {
                    id: dataPrestador.prestador[0].id,
                    prestador: dataPrestador.prestador[0].razonsocial,
                    especialidades: especialidadesPrestadorRecuperadas,
                    planes: planesPrestadorRecuperados
                };

                return prestadorRecuperado;
            }
        } else {
            return {id: 0, prestador: '', especialidades: [], planes: []};
        }
    } else {
        return {id: 0, prestador: '', especialidades: [], planes: []};
    }

    return {id: 0, prestador: '', especialidades: [], planes: []};
};

export default ObtenerPrestadorEspecialidades;